const normalizeString = (value) => (typeof value === 'string' ? value.trim() : '');

const hasValue = (value) => value !== null && value !== undefined && value !== '';

const hasValidId = (value) => {
  if (!hasValue(value)) {
    return false;
  }
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0;
};

const REQUIRED_PROFILE_FIELDS = [
  {
    label: 'Telefono',
    isMissing: (user) => !normalizeString(user?.phone) || !normalizeString(user?.phone_prefix),
  },
  {
    label: 'Paese',
    isMissing: (user) => !hasValidId(user?.country_id),
  },
  {
    label: 'Città',
    isMissing: (user) => !normalizeString(user?.city_strgin || user?.city),
  },
  {
    label: 'Azienda / Università',
    isMissing: (user) => !normalizeString(user?.company_name),
  },
  {
    label: 'Ruolo / Percorso formativo',
    isMissing: (user) => !normalizeString(user?.job_title),
  },
  {
    label: 'Categoria professionale',
    isMissing: (user) => !hasValidId(user?.job_category_id),
  },
  {
    label: 'Settore aziendale',
    isMissing: (user) => !hasValidId(user?.company_sector_id),
  },
  {
    label: 'CV',
    isMissing: (user) => !normalizeString(user?.cv_path),
  },
  {
    label: 'Foto profilo',
    isMissing: (user) => !normalizeString(user?.profile_photo_url || user?.profile_photo_path),
  },
];

export const evaluateProfileCompletion = (user) => {
  if (!user) {
    return {
      isComplete: true,
      missingFields: [],
    };
  }

  const missingFields = REQUIRED_PROFILE_FIELDS
    .filter((field) => field.isMissing(user))
    .map((field) => field.label);

  return {
    isComplete: missingFields.length === 0,
    missingFields,
  };
};
